var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CompassTooltip",
        {
          attrs: {
            content: _vm.$t.__(_vm.getExtensionOption(_vm.option).label),
            placement: "top",
            delay: { show: 0, hide: 1 },
            disabled: _vm.disabled
          }
        },
        [
          _c("CompassIconButton", {
            ref: "linkRichTextTrigger",
            attrs: {
              icon: _vm.getExtensionOption(_vm.option).icon,
              size: "small",
              disabled: _vm.disabled,
              active: _vm.activeStyle(_vm.option) || _vm.showMenuLink
            },
            on: {
              click: function($event) {
                _vm.showLinkMenu(_vm.editor.getAttributes("link").href)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassPopover",
        {
          attrs: {
            title: _vm.$t.__("richtext.customoptions.LinkRichText.add_link"),
            "custom-class": "custom-popover-link",
            triggerRef: "linkRichTextTrigger",
            isVisible: _vm.showMenuLink
          },
          on: { close: _vm.hideLinkMenu }
        },
        [
          _c(
            "div",
            { staticClass: "link-form-container" },
            [
              _c(
                "CompassFormItem",
                {
                  staticClass: "link-form-item-link",
                  attrs: {
                    label: _vm.$t.__(
                      "richtext.customoptions.LinkRichText.link"
                    ),
                    disabled: _vm.disabled,
                    required: "",
                    requiredLabel: _vm.$t.__("common.labels.required"),
                    error: _vm.errorUrlLink
                  }
                },
                [
                  _c("CompassInput", {
                    ref: "refInputLink",
                    attrs: {
                      disabled: _vm.disabled,
                      error: !!_vm.errorUrlLink
                    },
                    model: {
                      value: _vm.urlLink,
                      callback: function($$v) {
                        _vm.urlLink = $$v
                      },
                      expression: "urlLink"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.urlLink
                ? _c(
                    "CompassLink",
                    {
                      staticClass: "link-test",
                      class: _vm.errorUrlLink ? "link-test-error" : "",
                      attrs: {
                        label: _vm.$t.__(
                          "richtext.customoptions.LinkRichText.test_link"
                        ),
                        size: "small",
                        link: _vm.normalizeURL(_vm.urlLink),
                        target: "_blank"
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "suffix" },
                        [
                          _c("CompassIcon", {
                            attrs: { icon: "external-link", size: "small" }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("CompassCheckbox", {
                staticClass: "link-target",
                attrs: {
                  "model-value": "targetLink",
                  label: _vm.$t.__(
                    "richtext.customoptions.LinkRichText.open_new_tab"
                  ),
                  checked: _vm.targetLink,
                  "show-label": "",
                  disabled: _vm.disabled
                },
                on: {
                  change: function($event) {
                    _vm.targetLink = !_vm.targetLink
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "link-container-action" },
                [
                  _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__(
                        "richtext.customoptions.LinkRichText.delete_link"
                      ),
                      type: "tertiary",
                      size: "small",
                      disabled: !_vm.urlLink
                    },
                    on: { click: _vm.unUrlLink }
                  }),
                  _vm._v(" "),
                  _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("common.actions.cancel"),
                      type: "secondary",
                      size: "small"
                    },
                    on: { click: _vm.hideLinkMenu }
                  }),
                  _vm._v(" "),
                  _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("common.actions.validate"),
                      size: "small"
                    },
                    on: {
                      click: function($event) {
                        return _vm.setUrlLink(_vm.urlLink)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }